import PropTypes from 'prop-types';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { LD_CLIENT_ID } from './environment';

function LDProvider(props) {
  return <div>{props.children}</div>;
}

LDProvider.propTypes = {
  children: PropTypes.object,
};

const context = {
  kind: 'user',
  key: 'practice-anonymous',
};

export default withLDProvider({
  clientSideID: LD_CLIENT_ID,
  context,
})(LDProvider);
